import metaDescriptions from '@/data/metaDescription.json'

export const getSeoTitle = (name, designationLabel) => {
  return `${name} | ${designationLabel} Integrations`
}

export const getSeoDesc = (id, fallback) => {
  return metaDescriptions[id] || fallback
}
